import { AddressEndpoints } from "@ADDRESS";
import { useGET } from "@API2";
import { Select } from "antd";
import { useEffect, useState } from "react";
import { URLify } from "@HELPERS";

const { Option } = Select;

const Districts = (props) => {
  const [deliveryTypeState, setDeliveryTypeState] = useState(null);
  const { deliveryType } = props;
  const { data = [], loading } = useGET(
    `${AddressEndpoints.districts}?townId=${props.townId?.id}&deliveryType=${
      deliveryTypeState ? deliveryTypeState : ""
    }`,
    props.townId?.id && deliveryTypeState === deliveryType ? true : false
  );
  const [val, setVal] = useState(
    typeof props?.value === "object" ? props?.value?.id || null : null
  );

  useEffect(() => {
    if (deliveryType && deliveryTypeState !== deliveryType) {
      setDeliveryTypeState(deliveryType);
    }
  }, [deliveryType]);

  useEffect(() => {
    if (!loading) {
      const isSelectedExist = data.find((x) => x.id === val);
      if (
        !isSelectedExist &&
        val !== null &&
        (data.length > 0 || props.townId?.id === null)
      ) {
        props.onChange({ id: null, name: null });
        setVal(null);
        if (props.form) {
          props.form.setFieldsValue({
            [props.fieldName]: { recipientDistrict: null },
          });
        }
      }
      // eğer excelden geliyorsa string gelecek. onu data içerisinde bulup, seçtiriyoruz.
      // urlify ÇANKAYA gibi gelen bir datayı cankaya şekline dönüştürür. Böylece match etmesi kolaylaşır.
      if (typeof props.value === "string") {
        const that = data.find((x) => URLify(x.name) === URLify(props.value));
        if (that) {
          setVal(that.id);
          props.onChange({ id: that.id, name: that.name });
        }
      }
    }

    if (!props.value) {
      setVal(null);
    }
  }, [props, loading, data]);

  if (loading) {
    return <Select disabled loading placeholder="Yükleniyor..." />;
  } else {
    return (
      <>
        <Select
          onChange={(v) => {
            const current = data.find((x) => x.id === v);
            props.onChange({ id: current.id, name: current.name });
            setVal(current.id);
          }}
          loading={loading}
          showSearch
          disabled={props.disabled || false}
          value={val}
          filterOption={(input, option) =>
            option.name.indexOf(input.toLocaleLowerCase("tr")) >= 0
          }
        >
          {data.map((item) => (
            <Option
              key={item.id}
              value={item.id}
              name={item.name.toLocaleLowerCase("tr")}
            >
              {item.name}
            </Option>
          ))}
        </Select>
        {props.townId?.id && data.length < 1 && (
          <p style={{ color: "red" }}>
            Dağıtım alanımızda seçmiş olduğunuz ilçeye ait aktif mahalle
            bulunmamaktadır.
          </p>
        )}
      </>
    );
  }
};

export default Districts;
